import { render, staticRenderFns } from "./SalesContacts.vue?vue&type=template&id=8b8c7a4e&"
import script from "./SalesContacts.vue?vue&type=script&lang=js&"
export * from "./SalesContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports